var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIdCard = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.25 9C4.1565 8.023 5.8335 7.977 6.75 9M5.97 6C5.97 6.5525 5.5345 7 4.9965 7C4.459 7 4.023 6.5525 4.023 6C4.023 5.4475 4.459 5 4.9965 5C5.534 5 5.9705 5.4475 5.9705 6",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.75 2.00098C2.428 2.00598 1.7205 2.05198 1.2625 2.48598C0.75 2.97148 0.75 3.75298 0.75 5.31598V7.68448C0.75 9.24748 0.75 10.0295 1.2625 10.5145C1.775 11.0005 2.6 11.0005 4.25 11.0005H5.75C7.4 11.0005 8.225 11.0005 8.7375 10.515C9.25 10.029 9.25 9.24748 9.25 7.68498V5.31598C9.25 3.75298 9.25 2.97148 8.7375 2.48598C8.2795 2.05198 7.5725 2.00598 6.25 2.00098",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.88587 1.816C3.93387 1.6085 3.95787 1.5045 4.00387 1.42C4.06106 1.31946 4.13887 1.23215 4.2322 1.16381C4.32552 1.09548 4.43225 1.04766 4.54537 1.0235C4.64687 1 4.76487 1 4.99987 1C5.23487 1 5.35287 1 5.45437 1.0235C5.56749 1.04766 5.67422 1.09548 5.76754 1.16381C5.86087 1.23215 5.93868 1.31946 5.99587 1.42C6.04187 1.505 6.06587 1.6085 6.11387 1.816L6.15537 1.996C6.24037 2.3635 6.28287 2.5475 6.21887 2.689C6.17525 2.78292 6.10433 2.8615 6.01537 2.9145C5.87487 3 5.66587 3 5.24887 3H4.75087C4.33387 3 4.12487 3 3.98437 2.915C3.89533 2.86187 3.82441 2.7831 3.78087 2.689C3.71687 2.5475 3.75937 2.364 3.84437 1.996L3.88587 1.816Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIdCard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/id-card.11c06426.svg";
export { ForwardRef as ReactComponent };